import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BaseFooterLayoutComponent } from '../footer/footer.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        BaseFooterLayoutComponent
    ],
    exports: [
        BaseFooterLayoutComponent
    ],
   
})
export class BaseFooterLayoutModule { }
